import { post } from 'tools/request'
import { reactive } from 'alkali'
import { selectedOutcomes, groupedInterventions } from 'model/EvidenceSearch'
import { analysisSelections } from 'model/SearchQuery'
import { getCL } from 'components/analysis/AnalysisSettings'

export const metaAnalysisResults = reactive([])
export let metaAnalysisInputs

export function metaAnalysis(data) {
	let firstRow = data.valueOf()[0]
	if (!firstRow)
		throw new Error('Can not do meta analysis with zero rows')
	let firstOutcome = firstRow.row
	let isBinary = firstOutcome.type == 'Binary' || firstOutcome.dataType == 'Percentage'
	let dataType = firstOutcome.type == 'Binary' ? 'bin' :
		firstOutcome.type == 'Incidence' ? 'rate' :
		'cont'

	console.log('sending metaAnalysis')

	metaAnalysisInputs = {
		options: Object.assign({
			measureBin: 'RR',
			measureCont: 'MD',
			measureRate: 'IRR',
			"func":"uni",
			"method":"DL",
			"level":95,
			"drop00":false,
			"add":0.5,
			"trimfill":false,
			"knha":false,
			dataType,
			isPositive: Boolean(selectedOutcomes.valueOf()[0].isPositive),
			moderatorType: 'none',
			"package":"metafor",
			showStatements: true,
			personEvents: 1000,
		}, analysisSelections.settings.valueOf()),
		data: {
			data: data.map(( { row, cells, groups, study, isAnalyzable }) => {
				if (!isAnalyzable)
					return
				let N1 = cells[0].N || groups[0].N
				let N2 = cells[1].N || groups[1].N
				return {
					studyId: study.Id,
					study: study.name + ' (' + study.metadata.PublicationYear + ')',
					outcomeName: row.name,
					intervention: groups[0].OriginalName,
					comparator: groups[1].OriginalName,
					ai: isBinary ? cells[0].count || Math.round(cells[0].number * N1 / 100) : undefined,
					m1i: isBinary ? undefined : cells[0].number,
					x1i: dataType == 'rate' ? cells[0].count : undefined,
					t1i: dataType == 'rate' ? cells[0].totalPersonTime : undefined,
					sd1i: isBinary ? undefined : cells[0].sd,
					n1i: N1,
					unit1: row.unit,
					ci: isBinary ? cells[1].count || Math.round(cells[1].number * N2 / 100) : undefined,
					m2i: isBinary ? undefined : cells[1].number,
					x2i: dataType == 'rate' ? cells[1].count : undefined,
					t2i: dataType == 'rate' ? cells[1].totalPersonTime : undefined,
					n2i: N2,
					sd2i: isBinary ? undefined : cells[1].sd,
					unit2: row.unit,
					days: row.time?.days,
					UseAM: false
				}
			}).filter(data => data),
			outcomeName: selectedOutcomes.valueOf()[0].label,
			interventions: fixCase(groupedInterventions.valueOf()[0].label),
			comparators: fixCase(groupedInterventions.valueOf()[1]?.label || 'Control'),
			transformations: [],
		},
		rawData: {
			references: data.map(({ study }) => getStudyAsReference(study))
		},
	}
	let response = post('/portal/analysis/directMeta', {
		data: {
			data: metaAnalysisInputs.data,
			options: metaAnalysisInputs.options,
		}
	})
	metaAnalysisResults.put(response.then(results => {
		results.id = selectedTreatments.valueOf()[0].id
		results.dataType = dataType
		results.validStudyIds = results.studyId.filter((studyId, i) => results.valid[i])
		let totalN = 0
		data.forEach(({ cells, groups, study }) => {
			if (results.validStudyIds.includes(study.id + '')) {
				let N1 = cells[0].N || groups[0].N
				let N2 = cells[1].N || groups[1].N
				totalN += N1 + N2
			}
		})
		let SD = getCL()
		results.N = totalN
		let min = Math.min.apply(null, results.yi)
		let max = Math.max.apply(null, results.yi)
		let maxVariance = Math.max.apply(null, results.vi)
		let scale = 25 / (Math.max(max, -min) + Math.sqrt(maxVariance) * SD)
		results.scale = scale
		return [results]
	}))
	return response
}
function getStudyAsReference(study) {
	let studyData = study.metadata
	const doi ={
		href: studyData.FullTextURL || '',
		text: studyData.DOI || 'Unavailable',
	}
	return study.name + '. ' + studyData.Title + ' ' + studyData.Source + ' doi: [' + doi.text + '](' + doi.href + ')'
}

const fixCase = (word) => word[0].toUpperCase() + word.slice(1)
import { selectedTreatments } from './EvidenceSearch'


